var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2292 85.3359C11.1697 86.7486 5.20865 89.6032 5.20865 93.7945C5.20865 94.5057 5.0614 98.6706 11.6007 98.9578H17.5191M106.771 85.3359C113.83 86.7486 119.791 89.6032 119.791 93.7945C119.791 94.5057 119.939 98.6706 113.399 98.9578H107.481M76.2951 46.9106C76.2951 55.5597 69.9355 62.5712 62.0906 62.5712C54.2457 62.5712 47.8861 55.5597 47.8861 46.9106C47.8861 38.2615 54.2457 31.25 62.0906 31.25C69.9355 31.25 76.2951 38.2615 76.2951 46.9106ZM31.2504 91.9822C31.2504 83.5942 48.6931 79.169 62.5001 79.169C76.3071 79.169 93.7497 83.5942 93.7497 91.9822C93.7497 92.9431 93.946 98.5696 85.227 98.9576C73.8634 98.9576 69.5964 98.9583 62.5001 98.9583C55.4038 98.9583 51.1367 98.9576 39.7731 98.9576C31.0541 98.5696 31.2504 92.9431 31.2504 91.9822ZM36.1329 58.5938C36.1329 65.0658 31.542 70.3125 25.8789 70.3125C20.2159 70.3125 15.625 65.0658 15.625 58.5938C15.625 52.1217 20.2159 46.875 25.8789 46.875C31.542 46.875 36.1329 52.1217 36.1329 58.5938ZM88.8672 58.5938C88.8672 65.0658 93.4581 70.3125 99.1211 70.3125C104.784 70.3125 109.375 65.0658 109.375 58.5938C109.375 52.1217 104.784 46.875 99.1211 46.875C93.4581 46.875 88.8672 52.1217 88.8672 58.5938Z",
    stroke: "#EF233C",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.811a992853d120b689d8ceac5299caf9.svg";
export { ForwardRef as ReactComponent };